import { pathJoin } from '../../../../utils'
import { createLocationCreateRouteMap } from './create'
import { createLocationRouteMap } from './detailed-view'

export const createRoutesMapLocationMangementRouter = (prefix: string) => ({
  create: pathJoin(prefix)('create').chainMapAuto(createLocationCreateRouteMap),
  ':locationId': (locationId: string) =>
    pathJoin(prefix)(locationId).chainMapAuto(createLocationRouteMap),
})
